import firebase from 'firebase'
const firebaseConfig = {
    apiKey: "AIzaSyCOq_cnM_njKotEJkT5Ygij6uMj6Wg_6IA",
    authDomain: "cart-delivery-app.firebaseapp.com",
    projectId: "cart-delivery-app",
    storageBucket: "cart-delivery-app.appspot.com",
    messagingSenderId: "639432299843",
    appId: "1:639432299843:android:e7cba983bb07c9ccbbcbf6"
  };
  
  // Initialize Firebase
 firebase.initializeApp(firebaseConfig);
  
  export default firebase;